import { $ } from '../pages/assets';
import { i18n } from 'src/boot/i18n';
import { FELLOWKV2_URL } from 'src/pages/APIs';
import { downloadDocumentFile } from 'src/utils/download';

export default {
  methods: {
    removeExistingConfirmationOverlays(): void {
      const confirmationOverlay: HTMLElement | null = $(
        '#confirmation_overlay',
      );
      const scoreOverlay: HTMLElement | null = $('#score_overlay');
      if (confirmationOverlay) {
        confirmationOverlay.remove();
      }
      if (scoreOverlay) {
        scoreOverlay.remove();
      }
    },
    getLabelTranslation(key: any) {
      const value = '-';
      if (!key) {
        return value;
      }
      const translation_key = key as string;
      const translation = i18n.t(translation_key.toLowerCase());
      return translation === translation_key ? translation_key : translation;
    },
    getLabelTranslationIfExists(translation_key: string, title: string) {
      const value = '-';
      if (!translation_key) {
        return value;
      }

      const translation = i18n.t(translation_key.toLowerCase());
      return translation === translation_key ? title : translation;
    },

    handleImageBaseURL(images: any) {
      if (!images || !images[0]) {
        return '';
      }
      if (images[0].path.match(/doc2/g)) {
        return String(FELLOWKV2_URL);
      }

      return '';
    },

    sortNumbericArray(selectedSeparators: Array<number>) {
      selectedSeparators.sort(function (a: any, b: any) {
        return a - b;
      });
      return selectedSeparators;
    },
    getElementBorder(borderColor: string) {
      if (!borderColor) {
        return '';
      }

      return borderColor == 'error-border-left'
        ? 'error-checkbox-border'
        : 'success-checkbox-border';
    },

    getInputTextElementBorder(is_valid: boolean) {
      if (!is_valid) {
        return '';
      }

      return is_valid ? 'success-border-left' : 'error-border-left';
    },

    getCheckBoxElementBorder(is_valid: boolean) {
      if (!is_valid) {
        return '';
      }

      return is_valid ? 'success-checkbox-border' : 'error-checkbox-border';
    },

    downloadFile(record: any, docId: string, tokenQueryParam: string) {
      downloadDocumentFile(docId, record.filename, tokenQueryParam);
    },
  },
};
